import styled from "styled-components";

export const Container = styled.div``;

export const Title = styled.div`
  font-size: 5.4cqw;
  margin-bottom: 10px;
  font-weight: 200;
  text-align: center;
`;
export const TrashContainer = styled.div`
  justify-content: center;
  width: 100%;
  display: flex;
`;
export const Icon = styled.div`
  font-size: 2em;
  margin-right: 20px;
  margin-bottom: 10px;
`;
export const DateContainer = styled.div`
  font-size: 2.9cqw;
  font-weight: 100;
`;
